module.exports = __webpack_public_path__ + "img/kahnawake.848ac52a.png";